module.exports = __webpack_public_path__ + "img/amazon-fire.201d69ef.png";